"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Events
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropAgeGenderGenderEnum = exports.PropAgeGenderAgeRangeEnum = void 0;
exports.PropAgeGenderAgeRangeEnum = {
    _1317: '13-17',
    _1823: '18-23',
    _2449: '24-49',
    _5064: '50-64',
    _65: '65+',
};
exports.PropAgeGenderGenderEnum = {
    Female: 'Female',
    Male: 'Male',
    Nonbinary: 'Nonbinary',
    TransWoman: 'Trans Woman',
    TransMan: 'Trans Man',
    Genderqueer: 'Genderqueer',
    Other: 'Other',
    PreferNotToSay: 'Prefer Not to Say',
};
//# sourceMappingURL=prop-age-gender.js.map